import { css } from 'linaria';

export const noteText = css`
  margin-top: var(--space-300);
`;
